import { Component, OnInit } from '@angular/core';

import { ContractorService } from 'app/_services/contractor.service';
import { TokenStorageService } from '../../_services/token-storage.service';

@Component({
  selector: 'app-contractors',
  templateUrl: './contractors.component.html',
  styleUrls: ['./contractors.component.scss']
})
export class ContractorsComponent implements OnInit {
  contractorsList: any = [];
  profileInfo: any = [];
  capabilityInfo: any = [];

  constructor(
    private contractor: ContractorService,
    private tokenStorage: TokenStorageService,
  ) { }

  ngOnInit(): void {

    const contactUUID = this.tokenStorage.getToken() || "";
    
    this.contractor.getContractorsList$(contactUUID).subscribe({
      next: data => {
        this.contractorsList = data;
        console.log("contractorsList : ", this.contractorsList )
      }
    });
  }

}